export default "__VITE_ASSET__0870a316__"